
import { DocumentContentEditor } from "./DocumentContentEditor";

interface DigitalTransformationPlanViewProps {
  content: any;
  documentId: string;
  onUpdate: () => void;
}

export function DigitalTransformationPlanView({ content, documentId, onUpdate }: DigitalTransformationPlanViewProps) {
  return (
    <div className="space-y-8">
      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Current State Assessment</h2>
        <DocumentContentEditor
          section="Current State Assessment"
          content={content.currentStateAssessment}
          documentId={documentId}
          field="currentStateAssessment"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Future State Vision</h2>
        <DocumentContentEditor
          section="Future State Vision"
          content={content.futureStateVision}
          documentId={documentId}
          field="futureStateVision"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Gap Analysis</h2>
        <DocumentContentEditor
          section="Gap Analysis"
          content={content.gapAnalysis}
          documentId={documentId}
          field="gapAnalysis"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Transformation Roadmap</h2>
        <DocumentContentEditor
          section="Transformation Roadmap"
          content={content.transformationRoadmap}
          documentId={documentId}
          field="transformationRoadmap"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Change Management</h2>
        <DocumentContentEditor
          section="Change Management"
          content={content.changeManagement}
          documentId={documentId}
          field="changeManagement"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Success Metrics</h2>
        <DocumentContentEditor
          section="Success Metrics"
          content={content.successMetrics}
          documentId={documentId}
          field="successMetrics"
          onUpdate={onUpdate}
        />
      </section>
    </div>
  );
}
